// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"3c4b01bd","1673":"3c4b01bd","2199":"3c4b01bd","2568":"3c4b01bd","3597":"6ac541e9","9136":"0067a824"}[chunkId] + ".chunk.css";
};